import { render, staticRenderFns } from "./CRUDTags.vue?vue&type=template&id=284a5456&"
import script from "./CRUDTags.vue?vue&type=script&lang=js&"
export * from "./CRUDTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports